import { createApi } from '@reduxjs/toolkit/query/react';
import { customHandoverBaseQuery } from '../customBaseQuery';
import { CUSTOMER_SERVICE_NOTIFICATION_END_POINTS } from '../../constants/constant';
import {
  CustomerServiceNotificationComposePayload,
  CustomerServiceNotificationEntry,
  CustomerServiceNotificationListResponse,
  CustomerServiceNotificationLogListResponse,
  CustomerServiceNotificationSendRequest,
  CustomerServiceNotificationSendResponse,
  CustomerServiceNotificationTemplatesResponse,
} from '../../features/customerServiceNotifications/types';

export const customerServiceNotificationsApi = createApi({
  reducerPath: 'customerServiceNotificationsApi',
  baseQuery: customHandoverBaseQuery,
  tagTypes: ['CustomerServiceNotifications'],
  endpoints: builder => ({
    getCustomerServiceNotificationTemplates: builder.query<CustomerServiceNotificationTemplatesResponse, void>({
      query: () => ({
        url: CUSTOMER_SERVICE_NOTIFICATION_END_POINTS.templates,
        method: 'GET',
      }),
    }),
    composeCustomerServiceNotification: builder.mutation<
      CustomerServiceNotificationEntry,
      CustomerServiceNotificationComposePayload
    >({
      query: body => ({
        url: CUSTOMER_SERVICE_NOTIFICATION_END_POINTS.compose,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomerServiceNotifications'],
    }),
    sendCustomerServiceNotification: builder.mutation<
      CustomerServiceNotificationSendResponse,
      CustomerServiceNotificationSendRequest
    >({
      query: body => ({
        url: CUSTOMER_SERVICE_NOTIFICATION_END_POINTS.send,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomerServiceNotifications'],
    }),
    getCustomerServiceNotifications: builder.query<CustomerServiceNotificationListResponse, number | void>({
      query: limit => ({
        url: `${CUSTOMER_SERVICE_NOTIFICATION_END_POINTS.composed}?limit=${limit ?? 25}`,
        method: 'GET',
      }),
      providesTags: ['CustomerServiceNotifications'],
    }),
    getCustomerServiceNotificationLogs: builder.query<CustomerServiceNotificationLogListResponse, number | void>({
      query: limit => ({
        url: `${CUSTOMER_SERVICE_NOTIFICATION_END_POINTS.logs}?limit=${limit ?? 50}`,
        method: 'GET',
      }),
      providesTags: ['CustomerServiceNotifications'],
    }),
  }),
});

export const {
  useComposeCustomerServiceNotificationMutation,
  useGetCustomerServiceNotificationLogsQuery,
  useGetCustomerServiceNotificationsQuery,
  useGetCustomerServiceNotificationTemplatesQuery,
  useSendCustomerServiceNotificationMutation,
} = customerServiceNotificationsApi;
